import { z } from 'zod'
import { amountFieldSchema } from './amount'
import { identityFieldSchemas } from './identity'
import { paymentFieldSchemas } from './payment'
import { documentFieldSchemas } from './documents'
import { securityFieldSchemas } from './security'

export const cashoutFieldSchemas = {
  amount: amountFieldSchema,
  ...identityFieldSchemas,
  ...paymentFieldSchemas,
  ...documentFieldSchemas,
  ...securityFieldSchemas,
}
